var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mb-5"},[_c('div',{staticClass:"px-5 py-8 MonitorHeader sm:px-10 xl:rounded-lg"},[_c('DelegateCount'),_c('TotalForged'),_c('LastBlock')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }